import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { MoveIcon } from '../icons';
import ButtonGroup from '../../components/button-group';
import Select from '../../components/select';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './move-to-category.scss';

class MoveToCategory extends Component {
  state = {};
  constructor(props) {
    super(props);

    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);

    const categories = this.props.categories.filter(category => category._id !== this.props.currentCategoryId);
    this.state = {
      categoryId: categories.length ? categories[0]._id : null,
    };
  }

  handleCategoryChange(categoryId) {
    this.setState({ categoryId });
  }

  handleMove() {
    this.props.onClick(this.state.categoryId);
  }

  handleCancelClick() {
    this.props.onCancel();
  }

  render() {
    const { titleFontClassName, contentFontClassName, t, categories, currentCategoryId } = this.props;
    const className = classNames(styles.container, contentFontClassName, 'forum-text-color', 'move-to-category');
    const options = _(categories)
      .filter(category => category._id !== currentCategoryId)
      .map(category => ({
        label: category.label,
        value: category._id,
      }))
      .value();
    return (
      <div className={className}>
        <h3 className={classNames(styles.titleContainer, titleFontClassName)}>
          <MoveIcon className="forum-icon-fill"/>
          <span className={classNames(styles.title, 'move-to-category__title')}>
            {t('move-to-category.move-to-category')}
          </span>
        </h3>
        <div className={styles.message}>
          {this.props.message}
        </div>
        <div className={styles.selectWrapper}>
          <Select options={options} defaultValue={this.state.categoryId} onChange={this.handleCategoryChange}/>
        </div>
        <ButtonGroup
          primaryButtonText={t('move-to-category.move-post')}
          primaryButtonProps={{ onClick: this.handleMove }}
          secondaryButtonText={t('move-to-category.cancel')}
          secondaryButtonProps={{ onClick: this.handleCancelClick }}
        />
      </div>
    );
  }
}

MoveToCategory.propTypes = {
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  currentCategoryId: PropTypes.string,
  message: PropTypes.string,
};

export default withFontClassName(withTranslate(MoveToCategory));



// WEBPACK FOOTER //
// ./app/components/move-to-category/move-to-category.js